
import ParseExpression from './ParseExpression.js'
import ParseSentences from './ParseSentences.js'

function ParseSentenceWhile (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
}

ParseSentenceWhile.prototype = {
    parse () {
        let expType
        let expToken
        let whileStart
        let branchExitWhile
        let expectedToken
        let parseExpression = new ParseExpression(this.parser)
        let parseSentences = new ParseSentences(this.parser)

        this.parser.expect(this.SC.K_WHILE)

        if (this.parser.compile) {
            whileStart = this.pcode.instructionCount() + 1
        }

        expToken = this.scanner.next()

        expType = parseExpression.parse()

        if (!expType.isBool()) {
            this.parser.error(expToken, 'La expresión debe ser de tipo Logico.')
        }

        if (this.parser.compile) {
            branchExitWhile = this.pcode.branch(0, expToken)
        }

        expectedToken = this.parser.expect(this.SC.K_DO)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_DO])
        }

        parseSentences.parse()

        if (this.parser.compile) {
            // Repeat
            this.pcode.jump(whileStart, this.scanner.next())
        }

        expectedToken = this.parser.expect(this.SC.K_END_WHILE)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_END_WHILE], '\n')
        }

        if (this.parser.compile) {
            branchExitWhile.op1 = this.pcode.instructionCount() + 1
        }
    }
}

export default ParseSentenceWhile



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseSentenceWhile.js